import classNames from "classnames";
import React from "react";
import { Nav } from "react-bootstrap";

interface TabStripProps {
    eventKey: string;
    wrapped?: boolean;
    className?: string;
    onClick?: (e: any) => void;
    scrollTo?: (element: HTMLElement) => void;
    children: React.ReactNode;
    [x: string]: any;
}

export const TabStripItem = ({ eventKey, wrapped, className, onClick, scrollTo, children, ...props }: TabStripProps) => {
    const ref = React.useRef();

    const handleOnClick = (e) => {
        if (scrollTo) scrollTo(ref.current);
        else console.log("!scrollTo");

        if (onClick) onClick(e);
    };

    return (
        <Nav.Link
            {...props}
            eventKey={eventKey}
            onClick={handleOnClick}
            ref={ref}
            className={classNames(className, { "toolstrip-item-wrapped": wrapped })}
        >
            {children}
        </Nav.Link>
    );
};
